// src/routes/ViewPageWrapper.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import ViewPage from '../components/ViewPage';
import ProtectedRoute from '../components/ProtectedRoute';

const ViewPageWrapper = () => {
  const { id } = useParams();
  return <ProtectedRoute element={<ViewPage />} pageId={parseInt(id)} />;
};

export default ViewPageWrapper;
